/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Box, AppBar, Toolbar, Typography } from "@mui/material";
import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Button,
  Menu,
  MenuItem,
} from "@mui/material";
import { Link, Route, Routes, Navigate } from "react-router-dom";
import Logo from "../Images/Livon2vLogo.png";
import "../css/Dashboard.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBox,
  faClipboard,
  faUsers,
  faBars,
  faUser,
  faImages,
  faBlog,
} from "@fortawesome/free-solid-svg-icons";
import Products from "./Products/Products";
import ProductDetails from "./Products/ProductDetails";
import AddProduct from "./Products/AddProduct";
import OrderList from "./orders/OrderList";
import CustomersList from "./Customers/CustomersList";
import UserManagement from "./UserManagement/userManagement";
import axios from "axios";
import UserProfile from "./UserManagement/userprofile";
import CustomerDetails from "./Customers/CustomerDetails ";
import OrderDetails from "./orders/OrderDetails";
import baseUrl from "../Environment";
import BannerCarousel from "./Banner/BannerCarousel";
import AdditionalInfo from "./Additional Info/AdditionalInfo";
import BlogUploadPage from "./Blog/BlogUploadPage";
import BlogList from "./Blog/BlogList";
const AdminPanel = () => {
  const [selectedTab, setSelectedTab] = useState("All-products");
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false); // To toggle sidebar
  const [userData, setUserData] = useState();
  const [anchorEl, setAnchorEl] = useState(null);

  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed); // Toggle the sidebar state
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const phoneNumber = localStorage.getItem("phoneNumber");
  const LoadUser = async () => {
    try {
      const data = await axios
        .get(`${baseUrl}user/get/${phoneNumber}`)
        .then((response) => response.data);
      if (data) {
        setUserData(data.user.users);
      }
    } catch (error) {}
  };
  useEffect(() => {
    LoadUser();
  }, [phoneNumber]);
  return (
    <div>
      <Box sx={{ display: "flex" }}>
        <Drawer
          variant="permanent"
          sx={{
            width: isSidebarCollapsed ? 80 : 240,
            flexShrink: 0,
            "& .MuiDrawer-paper": {
              width: isSidebarCollapsed ? 80 : 240,
              boxSizing: "border-box",
            },
          }}
        >
          <Box
            className={`d-flex ${isSidebarCollapsed ? "justify-content-center" : "justify-content-between"}  align-items-center p-2`}
          >
            {!isSidebarCollapsed && (
              <Link to="/">
                <img
                  src={Logo}
                  alt="Logo"
                  className="Logo"
                  style={{ maxWidth: "80%" }}
                />
              </Link>
            )}
            <FontAwesomeIcon
              icon={faBars}
              onClick={toggleSidebar}
              className="text-dark p-2"
              style={{ cursor: "pointer", fontSize: "20px" }}
            />
          </Box>
          <List>
            <ListItem disablePadding>
              <ListItemButton
                component={Link}
                to="/All-products"
                selected={selectedTab === "All-products"}
                onClick={() => setSelectedTab("All-products")}
                sx={{
                  justifyContent: isSidebarCollapsed ? "center" : "flex-start",
                }}
              >
                <ListItemIcon sx={{ justifyContent: "center" }}>
                  <FontAwesomeIcon icon={faBox} />
                </ListItemIcon>
                {!isSidebarCollapsed && <ListItemText primary="Products" />}
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
              <ListItemButton
                component={Link}
                to="/All-Orders"
                selected={selectedTab === "View Orders"}
                onClick={() => setSelectedTab("View Orders")}
                sx={{
                  justifyContent: isSidebarCollapsed ? "center" : "flex-start",
                }}
              >
                <ListItemIcon sx={{ justifyContent: "center" }}>
                  <FontAwesomeIcon icon={faClipboard} />
                </ListItemIcon>
                {!isSidebarCollapsed && <ListItemText primary="Orders" />}
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
              <ListItemButton
                component={Link}
                to="/All-Customers"
                selected={selectedTab === "View Customers"}
                onClick={() => setSelectedTab("View Customers")}
                sx={{
                  justifyContent: isSidebarCollapsed ? "center" : "flex-start",
                }}
              >
                <ListItemIcon sx={{ justifyContent: "center" }}>
                  <FontAwesomeIcon icon={faUsers} />
                </ListItemIcon>
                {!isSidebarCollapsed && <ListItemText primary="Customers" />}
              </ListItemButton>
            </ListItem>
            <ListItem disablePadding>
              <ListItemButton
                component={Link}
                to="/userManagement"
                selected={selectedTab === "User Management"}
                onClick={() => setSelectedTab("User Management")}
                sx={{
                  justifyContent: isSidebarCollapsed ? "center" : "flex-start",
                }}
              >
                <ListItemIcon sx={{ justifyContent: "center" }}>
                  <FontAwesomeIcon icon={faUser} />
                </ListItemIcon>
                {!isSidebarCollapsed && (
                  <ListItemText primary="User Management" />
                )}
              </ListItemButton>
            </ListItem>
            {/* <ListItem disablePadding>
              <ListItemButton
                component={Link}
                to="/bannercarousel"
                selected={selectedTab === "Banner"}
                onClick={() => setSelectedTab("Banner")}
                sx={{
                  justifyContent: isSidebarCollapsed ? "center" : "flex-start",
                }}
              >
                <ListItemIcon sx={{ justifyContent: "center" }}>
                  <FontAwesomeIcon icon={faImages} />
                </ListItemIcon>
                {!isSidebarCollapsed && <ListItemText primary="Banner" />}
              </ListItemButton>
            </ListItem> */}
            <ListItem disablePadding>
              <ListItemButton
                component={Link}
                to="/blog"
                selected={selectedTab === "Blog"}
                onClick={() => setSelectedTab("Blog")}
                sx={{
                  justifyContent: isSidebarCollapsed ? "center" : "flex-start",
                }}
              >
                <ListItemIcon sx={{ justifyContent: "center" }}>
                  <FontAwesomeIcon icon={faBlog} />
                </ListItemIcon>
                {!isSidebarCollapsed && <ListItemText primary="Blog" />}
              </ListItemButton>
            </ListItem>
            {/* <ListItem disablePadding>
              <ListItemButton
                component={Link}
                to="/additional-info"
                selected={selectedTab === "Product Additinal Info"}
                onClick={() => setSelectedTab("Product Additinal Info")}
                sx={{
                  justifyContent: isSidebarCollapsed ? "center" : "flex-start",
                }}
              >
                <ListItemIcon sx={{ justifyContent: "center" }}>
                  <FontAwesomeIcon icon={faImages} />
                </ListItemIcon>
                {!isSidebarCollapsed && (
                  <ListItemText primary="Product Additinal Info" />
                )}
              </ListItemButton>
            </ListItem> */}
          </List>
        </Drawer>
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 3,
            width: `calc(100% - ${isSidebarCollapsed ? 80 : 240}px)`,
          }}
        >
          <AppBar
            position="sticky"
            sx={{
              zIndex: 1201,
              background: "#fff",
              boxShadow: "none",
            }}
          >
            <Toolbar>
              <Typography
                variant="h6"
                component="div"
                sx={{ flexGrow: 1 }}
              ></Typography>
              <div
                style={{
                  borderBottom: "1px solid #ddd",
                }}
              >
                {userData &&
                  userData.map((user, index) => (
                    <Button
                      key={index}
                      onClick={handleMenuOpen}
                      sx={{
                        textTransform: "none",
                        color: "#1976d2",
                        fontWeight: "bold",
                        ":hover": {
                          backgroundColor: "rgba(25, 118, 210, 0.1)",
                        },
                      }}
                      style={{
                        fontSize: "18px",
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faUser}
                        style={{ marginRight: "8px", color: "#1976d2" }}
                      />
                      {user?.name}
                    </Button>
                  ))}
                <Menu
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleMenuClose}
                  sx={{
                    "& .MuiPaper-root": {
                      backgroundColor: "#f5f5f5",
                      borderRadius: "8px",
                      boxShadow: "none",
                    },
                  }}
                  MenuListProps={{
                    sx: {
                      width: anchorEl ? anchorEl.offsetWidth : "auto",
                      padding: 0,
                    },
                  }}
                >
                  <MenuItem
                    component={Link}
                    to="/userProfile"
                    onClick={handleMenuClose}
                    sx={{
                      fontWeight: "bold",
                      color: "#333",

                      justifyContent: "space-evenly",
                      padding: "8px 16px",
                      ":hover": {
                        backgroundColor: "#1976d2",
                        color: "#fff",
                      },
                    }}
                  >
                    <span className="bi bi-person-check"></span> Profile
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      localStorage.removeItem("phoneNumber");
                      window.location.href = "/login";
                      handleMenuClose();
                    }}
                    sx={{
                      fontWeight: "bold",
                      color: "#333",
                      justifyContent: "space-evenly",
                      padding: "8px 16px",
                      ":hover": {
                        backgroundColor: "#1976d2",
                        color: "#fff",
                      },
                    }}
                  >
                    <span className="bi bi-box-arrow-right"></span> Logout
                  </MenuItem>
                </Menu>
              </div>
            </Toolbar>
          </AppBar>
          <Routes>
            <Route path="/All-products" element={<Products />} />
            <Route
              path="/productsDetails/:productTitle"
              element={<ProductDetails />}
            />
            <Route path="/Add-Product" element={<AddProduct />} />
            <Route path="/All-Orders" element={<OrderList />} />
            <Route path="/order-details/:orderId" element={<OrderDetails />} />
            <Route
              path="/customer-details/:customerId"
              element={<CustomerDetails />}
            />
            <Route path="/All-Customers" element={<CustomersList />} />
            <Route path="/userManagement" element={<UserManagement />} />
            <Route path="/userProfile" element={<UserProfile />} />
            {/* <Route path="/bannercarousel" element={<BannerCarousel />} /> */}
            <Route path="/blog" element={<BlogList />} />
            <Route path="/blog/new" element={<BlogUploadPage />} />
            <Route path="/blog/edit/:id" element={<BlogUploadPage />} />
            {/* <Route path="/additional-info" element={<AdditionalInfo />} /> */}
            <Route path="*" element={<Navigate to="/All-products" replace />} />
          </Routes>
        </Box>
      </Box>
    </div>
  );
};
export default AdminPanel;
